









import { defineComponent, PropType, computed } from '@vue/composition-api'

export type SelectOption = Record<string | number, string>
export type SelectOptions = Array<SelectOption>

export default defineComponent({
  props: {
    placeholder: {
      type: String,
      default: 'Select...'
    },
    multiple: Boolean,
    name: String,
    value: [Array, String],
    options: Array as PropType<SelectOptions>
  },

  setup(props, { emit }) {
    const selected = computed({
      get: () => props.value,
      set: (value: unknown[] | string[] | string | undefined) =>
        emit('input', value)
    })

    return {
      selected
    }
  }
})
